import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ICountryList } from "../../../Pages/Yearlevel_map/IYearlevel_map";

export const ListCountryListSlice = createSlice({
  name: "ListCountryListSlice",
  initialState: {} as IReduxState<ICountryList[]>,
  reducers: {
    listCountryList: (state) => {
      state.isLoading = true;
    },
    successlistCountryList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistCountryList: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistCountryList,
  listCountryList,
  successlistCountryList,
} = ListCountryListSlice.actions;

export default ListCountryListSlice.reducer;
